module.exports = __webpack_public_path__ + "static/media/login-bg-2.24a63ad6.jpg";